import { CommonHelperFunctions, IApiManagementDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class ApiManagementService {
  public static async Create(screenDesignDocument: IApiManagementDto): Promise<AxiosResponse> {
    return Axios.post<IApiManagementDto, AxiosResponse>(`${backendUrl}/apiManagement/create`, screenDesignDocument);
  }

  public static async Update(id: string, obj: IApiManagementDto): Promise<AxiosResponse> {
    return Axios.put<IApiManagementDto, AxiosResponse>(`${backendUrl}/apiManagement/update/${id}`, obj);
  }

  public static async Delete(id: string): Promise<boolean> {
    try {
      await Axios.delete<null>(`${backendUrl}/apiManagement/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async Get(id: string): Promise<AxiosResponse<IApiManagementDto>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/apiManagement/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetAllByProjectId(id: string): Promise<AxiosResponse<IApiManagementDto[]>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/apiManagement/getallbyprojectid/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetCodeGenerationApiUrl(): Promise<AxiosResponse<IApiManagementDto[]>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/apiManagement/codegenerationapiurl/`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
